<template>
  <li>
    <a
      v-if="!appInfo.additionalUrls"
      itemprop="url"
      :href="appUrl"
      :class="{ 'active': active }">
      {{ title }}
    </a>
    <a
      v-else
      itemprop="url"
      href="#"
      @mouseover.prevent="expanded = true"
      :class="{ 'active': active }">
      {{ title }}
    </a>
    <template>
      <ul
        itemscope
        itemtype="http://schema.org/SiteNavigationElement"
        class="dropdown-menu"
        v-show="expanded"
        @mousedown.prevent
        @mouseover.prevent="expanded = true"
        @mouseleave.prevent="expanded = false"
        >
        <li :class="{active: isAdditionalActive(appUrl)}"><a itemprop="url" :href="appUrl">{{ title }}</a></li>
        <li
          v-for="(additional, index) of appInfo.additionalUrls"
          :key="index"
          :class="{active: isAdditionalActive(appUrl+`/${additional.url}`)}">
          <a itemprop="url" :href="appUrl+`/${additional.url}`">{{ $t(additional.headerTitleT) }}</a>
        </li>
      </ul>
    </template>
  </li>
</template>

<script>
export default {
  name: 'LandingHeaderDesktopItem',
  props: {
    appInfo: { type: Object },
    active: { type: Boolean, default: false },
    title: { type: String },
    locale: { type: String }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    appUrl () {
      return `/${this.locale}/${this.appInfo.url}`
    }
  },
  methods: {
    onClick () {
      this.expanded = true
    },
    isAdditionalActive (pagePath) {
      const currentUrl = new URL(window.location.href)
      const path = currentUrl.pathname
      return path === pagePath
    }
  }
}
</script>
